import React from 'react';
import * as PropTypes from 'prop-types';

import { VideoShareDropdownDecorated } from 'components/context-menu/video-share-dropdown';
import { DownloadVideo, PinUnpinVideoDecorated } from 'components/video-box/index';
import { VideoContextMenuDecorated } from 'components/video-context-menu';

export const VideoControlsMenu = ({ video }) => {
  return (
    <React.Fragment>
      <DownloadVideo video={video} />
      <PinUnpinVideoDecorated video={video} />
      <VideoShareDropdownDecorated />
      <VideoContextMenuDecorated video={video} testPrefix="channel-page-" />
    </React.Fragment>
  );
};

VideoControlsMenu.propTypes = {
  video: PropTypes.object.isRequired,
};
